import { useEffect, useState } from 'react';

/**
 * Sticky 헤더 기능 훅
 * 원본 main.js의 sticky 로직과 동일하게 동작
 */
export const useStickyHeader = () => {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    let pendingStickyUpdate = false;

    const handleScroll = () => {
      const scroll = window.scrollY || document.documentElement.scrollTop;

      // Sticky 헤더 처리
      if (!pendingStickyUpdate) {
        pendingStickyUpdate = true;
        requestAnimationFrame(() => {
          const headerTopHeight =
            document.querySelector('.header-top')?.offsetHeight ?? 0;
          const headerBottomHeight =
            document.querySelector('.header-bottom')?.offsetHeight ?? 0;
          const stickyThreshold = headerTopHeight + headerBottomHeight;

          if (scroll < stickyThreshold) {
            setIsSticky(false);
          } else {
            setIsSticky(true);
          }
          pendingStickyUpdate = false;
        });
      }
    };

    // 스크롤 이벤트 리스너 등록
    window.addEventListener('scroll', handleScroll, { passive: true });

    // 초기 상태 확인
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return isSticky;
};

